module.exports = __webpack_public_path__ + "static/media/Dad-profile-pic.ecdd5f35.jpeg";